import { render, staticRenderFns } from "./EditProfileCard.vue?vue&type=template&id=141a63aa"
import script from "./EditProfileCard.vue?vue&type=script&lang=js"
export * from "./EditProfileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports